import { render, staticRenderFns } from "./ArchiveMessageModal.vue?vue&type=template&id=702a9c30&scoped=true"
import script from "./ArchiveMessageModal.vue?vue&type=script&lang=js"
export * from "./ArchiveMessageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702a9c30",
  null
  
)

export default component.exports